module.exports = __webpack_public_path__ + "6685093bf69912cf6029756fa4507525.svg";